import { IconArrowRight } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import React from "react";

interface ArrowLinkProps {
  children?: React.ReactNode;
  href?: string;
  className?: string;
}

export const ArrowLink = ({ href, children, className }: ArrowLinkProps) => (
  <Button
    variant="linkColor"
    size="sm"
    asChild
    className={cn("[&_svg]:hover:translate-x-1", className)}
  >
    <a href={href}>
      {children}
      <IconArrowRight className="transition-transform duration-200" />
    </a>
  </Button>
);
